/* global  attachEvent */

// *******************************************************************************
// 1.0 - Toggle Tooltip
// *******************************************************************************

attachEvent('.tooltip__question', 'click', (ev) => {
  const tooltip = ev.target.closest('.tooltip');
  const tooltipText = tooltip.querySelector('.tooltip__text-wrapper');

  tooltipText.classList.toggle('is-open');
});
